import { SET_TIME_RECORDING_DATE_SELECTION } from '../actionTypes';

/**
 * @param {Redux.TimeRecordingDateSelection.State} state
 * @param {Redux.TimeRecordingDateSelection.Action} action
 * @returns {Redux.TimeRecordingDateSelection.State}
 */
const timeRecordingDateSelection = (state = null, action) => {
  if (action.type === SET_TIME_RECORDING_DATE_SELECTION) {
    return action.selectedDate;
  }

  return state;
};

export default timeRecordingDateSelection;
